export function groupCollectionBy(collection: any[], key: string) {
    return collection.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}
